import { makeStyles } from '@material-ui/core/styles';

export const QueerifyStyles = makeStyles((theme) => ({
    root: {
        padding: `${theme.spacing(4)}px 0`
    },
}));

export const InputStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: `0 ${theme.spacing(2)}px ${theme.spacing(2)}px 0`,
            width: '25ch',
        },
    },
}));

export const SelectStyles = makeStyles((theme) => ({
    formControl: {
        margin: `0 ${theme.spacing(2)}px ${theme.spacing(2)}px 0`,
        minWidth: 120,
    }
}));

export const CanvasStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(1),
        marginBottom: theme.spacing(2),
        overflow: "auto"
    },
    input: {
        display: 'none',
      },
}));

